export default function isAnyFilterEnabled(filters: { [k: string]: any }) {
  return (
    Object.values(filters).findIndex(
      (value) => value !== null && value !== '',
    ) > -1
  );
}
